<style scoped>
    .travel-order{
        padding: 10px;
        border: 1px solid #dddee1;
        margin-bottom: 10px;
    }
    .value{
        font-size: 14px;
        font-weight: bold;
    }
    .attachment{
        display: inline-block;
        vertical-align: top;
        width: 120px;
        margin-right: 5px;
    }
    .attachment:hover{
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(55,55,55,.3);
    }
    .attachment img{
        width: 100%;
    }
</style>
<template>
  <div>
    <div
      v-if="asset_order.user_flow"
      class="line"
    >
      <UserFlow :user_flow="asset_order.user_flow" />
    </div>
    <div class="travel-order">
      <template>
        <Row>
          <i-col span="5">
            <span>资产名称:</span>
            <span class="value">
              <span>{{ asset_order.asset_name_str }}</span>
            </span>
          </i-col>
          <i-col span="5">
            <span>资产型号:</span>
            <span class="value">{{ asset_order.asset_version ? asset_order.asset_version.name : asset_order.asset_model }}</span>
          </i-col>
          <i-col span="5">
            <span>领用数量:</span>
            <span class="value">{{ asset_order.count || '-' }}</span>
          </i-col>
          <!-- <i-col span="11">
                        <span>出程</span>
                    </i-col> -->
        </Row>
        <div class="line">
          <span>领用原因:</span>
          <span>{{ asset_order.lead_reason || '未填写' }}</span>
        </div>
        <Row style="margin-top:5px">
          <i-col span="5">
            <span>期望领用日期:</span>
            <span class="value">{{ asset_order.expect_lead_date }}</span>
          </i-col>
        </Row>
        <Divider>库存信息</Divider>
        <InventoryInfo :asset-order="asset_order" />
      </template>
    </div>
  </div>
</template>
<script>
    // import FileUploader from '../../components/file/uploader';
    // import ImagePreview from '../../components/image/image_preview';
  import InventoryInfo from './inventory_info'
  export default {
    // components: { FileUploader, ImagePreview },
    components: { InventoryInfo },
    props: {
      asset_order_id: {
        type: Number,
        'default': 0
      },
      show_handles: {
        type: Boolean,
        'default': false
      }
    },
    data() {
      return {
        loading: false,
        asset_order: {
        },
        id_map: {
          0: '护照',
          1: '身份证',
          2: '港澳台居民居住证',
          3: '台胞证',
          4: '回乡证'
        },
        public_attachment_upload_path: Util.api.public_attachment_upload_path,
        edit_item: {
          bfiles: []
        },
        edit_config: {
          modal: false,
          loading: true
        },
        upload_format: ['jpg', 'jpeg', 'png']
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      this.getDetail()
      //
      // console.log('travel_order.items', this.travel_order.items[0].desc.replace(/(\r\n|\n|\r)/gm, "<br />"))
    },
    mounted() {
      //
    },
    methods: {
      getDetail() {
        this.loading = true;
        this.$util.ajax(this.$util.api.asset_order_detail, {
          params: {
            id: this.asset_order_id
          }
        }).then(res => {
          if (res.data.code === 1) {
            this.asset_order = res.data.data
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.data.msg
            })
          }
        }).catch(e => {
          this.$Modal.error(e)
        }).finally(() => {
          this.loading = false
        })
      },
      showLine(desc) {
        return desc.replace(/(\r\n|\n|\r)/gm, '<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
      },
      getTravelType(type) {
        if (type === 0) {
          return 'fei'
        }
      },
      fileUploaded(file) {
        this.edit_item.bfiles.push(file);
      },
      editItem(item) {
        this.edit_item = Util.clone(item);
        this.edit_config.modal = true;
      },
      editItemOK() {
        Util.ajax.post(Util.api.update_travel_order_item_info, this.edit_item).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            Util.insertOrUpdateArrayItem(this.travel_order.items, data.item);
            this.edit_config.modal = false;
          } else {
            this.resetEditLoading();
            this.$Modal.error({
              title: '提示',
              content: res.msg
            })
          }
        }).catch((e) => {
          this.resetEditLoading();
          this.$Modal.error({
            title: '提示',
            content: e.message
          })
        });
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 500);
      },
      confirmDeleteFile(bfile) {
        this.$Modal.confirm({
          title: '删除确认',
          content: `你确定要删除 ${bfile.name} 吗?`,
          onOk:() => {
            Util.ajax.post(Util.api.delete_model_file, {
              bfile_id: bfile.id,
              link_model_type: 'TravelOrderItem',
              link_model_id: this.edit_item.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              if (data.code === 1) {
                Util.removeArrayItem(this.edit_item.bfiles, bfile);
              } else {
                this.$Modal.error({
                  title: '提示',
                  content: data.msg
                })
              }
            }).catch((e) => {
              console.log(e);
              this.$Modal.error({
                title: '提示',
                content: e.message
              })
            });
          }
        });
      },
      publicFilePath(file) {
        return Util.publicAttachmentUrl(file);
      }
    }
  }
</script>
